import React from 'react'

//components
import Modal from '../../modal'
//types
import { IneligibleOrderModalProps } from 'types'

const IneligibleBalanceModal = ({ showModal, hideModal }: IneligibleOrderModalProps) => {
  return (
    <Modal
      showModal={showModal}
      hideModal={hideModal}
      text="Sorry, looks like you don’t have the requirements for that Gift Card yet. Keep earning!"
    />
  )
}

export default IneligibleBalanceModal
